import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { typeInputTyping } from '../../../../common/datePicker/constants'
import InputSingleDate from '../../../../common/datePicker/InputSingleDate'
import InputTypingDate from '../../../../common/datePicker/InputTypingDate'
import { Element } from '../../../../common/html/element'
import { Icon } from '../../../../common/html/icon'
import { changeFilter, selectFilter } from '../store/slice'
import classes from './index.module.scss'

export const DateRange = () => {
  const dispatch = useDispatch()

  const from = useSelector(selectFilter('from'))
  const to = useSelector(selectFilter('to'))

  const onFromChange = (from) => {
    dispatch(changeFilter({ from, page: 1 }))
  }

  const onToChange = (to) => {
    dispatch(changeFilter({ to, page: 1 }))
  }

  return (
    <Element className="dFlex alignItemsCenter gap1">
      <Element>
        <Translate value="screening.DATE_MODIFIED" />
      </Element>
      <InputDate
        defaultDate={from ? from : undefined}
        value={from}
        onChange={onFromChange}
      />
      <InputDate
        defaultDate={to ? to : undefined}
        value={to}
        onChange={onToChange}
      />
    </Element>
  )
}

const InputDate = ({ defaultDate, value, onChange }) => {
  return (
    <Element className={classes.date}>
      <InputSingleDate defaultDate={defaultDate} onSubmit={onChange}>
        <Element className={classes.input} style={{ borderColor: '#E0E0E0' }}>
          <InputTypingDate
            date={value}
            onChange={onChange}
            typeInput={typeInputTyping.SINGLE_DATE}
            style={{ border: 'none', outline: 'none' }}
          />
          <Icon
            className="icon-calendar"
            style={{ fontSize: 16, color: '#9C9C9C' }}
          />
        </Element>
      </InputSingleDate>
    </Element>
  )
}
